import React from "react";
import moment from "moment";

import { Box, Row, StaticField } from "@intech/web-ui";

import { LoadingComponent } from "../../../../components/LoadingComponent";

interface IProps {
  saldo: any[] | null
}

export const Historico: React.FC<IProps> = ({
  saldo
}) => {

  function DecimalDigitDisplay(Value: number, DecimalDigits: number) {
    if (Value === undefined)
      Value = 0;
    return (
      Value.toLocaleString('pt-br', { minimumFractionDigits: DecimalDigits, maximumFractionDigits: DecimalDigits })
    );
  }

  if (saldo !== null && saldo !== undefined && saldo.length > 0) {
    return (
      <Box title={"Histórico"}>
        <div className={"table-responsive"}>
          <table className={"table table-bordered table-striped table-hover"}>
            <thead>
              <tr className={"text-center"}>
                <th>Referência</th>
                <th>Benefício em Cotas</th>
                <th>Benefício em Reais</th>
                <th>Saldo em Cotas</th>
                <th>Valor da Cota</th>
                <th>Rentabilidade</th>
                <th>Saldo em Reais</th>
              </tr>
            </thead>
            <tbody>
              {saldo.map((item: any, index: number) => {
                return (
                  <tr key={index}>
                    <td className={"text-center"}>
                      <StaticField
                        value={moment(item.DT_REFERENCIA, "DD/MM/yyyy").format("MM/yyyy")}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={DecimalDigitDisplay(item.VALOR_COTAS, 8)}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={item.VALOR_REAIS}
                        type={"money"}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={DecimalDigitDisplay(item.SALDO_ATUAL, 8)}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={DecimalDigitDisplay(item.VALOR_IND2, 8)}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={DecimalDigitDisplay(item.RENTABILIDADE, 2) + "%"}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={item.SALDO_ATUAL_REAIS}
                        type={"money"}
                      />
                    </td>
                  </tr>
                )
              })}


            </tbody>
          </table>
        </div>
      </Box>
    )
  }

  return (
    <LoadingComponent />
  );
}